module.exports = __webpack_public_path__ + "img/yishi10.e8568244.jpg";